import { defineComponent as h, onMounted as R, onUnmounted as z, ref as y, computed as k, openBlock as s, createBlock as r, unref as a, withCtx as i, createElementVNode as p, createVNode as v, renderSlot as b, createCommentVNode as g, Teleport as N, Transition as W, normalizeStyle as F, normalizeClass as L, createElementBlock as T, Fragment as V, renderList as O, toDisplayString as P } from "vue";
import U from "./index60.js";
import { Menu as X, MenuButton as Y, MenuItems as j, MenuItem as S } from "./index271.js";
const q = { class: "base-menu__item-content" }, D = { class: "base-menu__item-text" }, A = 8, K = /* @__PURE__ */ h({
  __name: "BaseMenu",
  props: {
    items: {},
    showIcons: { type: Boolean, default: !1 },
    menuWidth: { default: 180 },
    align: { default: "center" },
    itemsClass: { default: "" }
  },
  emits: ["select"],
  setup(w, { emit: C }) {
    const M = h({
      name: "BaseMenuScrollSync",
      props: {
        triggerRef: {
          type: Object,
          required: !0
        }
      },
      emits: ["scroll"],
      setup(e, { emit: n }) {
        const t = [], o = () => n("scroll");
        return R(() => {
          const c = e.triggerRef?.value?.value ?? null;
          if (!c) return;
          let u = c.parentElement;
          for (; u; ) {
            const { overflowX: d, overflowY: I } = getComputedStyle(u);
            (/(auto|scroll|overlay)/.test(d) || /(auto|scroll|overlay)/.test(I)) && t.push(u), u = u.parentElement;
          }
          t.push(window), t.forEach((d) => d.addEventListener("scroll", o, !0));
        }), z(() => {
          t.forEach((c) => c.removeEventListener("scroll", o, !0));
        }), () => null;
      }
    }), l = w, m = y(null), E = k(() => ({ value: m })), f = y({ top: 0, left: 0 }), x = k(() => {
      const e = l.align === "center" ? "translateX(-50%)" : "none";
      return {
        top: `${f.value.top}px`,
        left: `${f.value.left}px`,
        width: `${l.menuWidth}px`,
        transform: e
      };
    }), _ = () => {
      const e = m.value;
      if (e) {
        const n = e.getBoundingClientRect();
        let t;
        l.align === "right" ? t = Math.max(0, n.right - l.menuWidth) : l.align === "left" ? t = Math.max(0, n.left) : t = n.left + n.width / 2, f.value = {
          top: n.bottom + A,
          left: t
        };
      }
    }, B = C, $ = (e) => {
      B("select", e);
    };
    return (e, n) => (s(), r(a(X), {
      as: "div",
      class: "relative inline-block"
    }, {
      default: i(({ open: t }) => [
        p("div", {
          ref_key: "triggerRef",
          ref: m,
          onClick: _
        }, [
          v(a(Y), null, {
            default: i(() => [
              b(e.$slots, "trigger")
            ]),
            _: 3
          })
        ], 512),
        t ? (s(), r(a(M), {
          key: 0,
          "trigger-ref": E.value,
          onScroll: _
        }, null, 8, ["trigger-ref"])) : g("", !0),
        (s(), r(N, { to: "#overlay-root" }, [
          v(W, {
            "enter-active-class": "transition duration-100 ease-out",
            "enter-from-class": "transform scale-95 opacity-0",
            "enter-to-class": "transform scale-100 opacity-100",
            "leave-active-class": "transition duration-75 ease-in",
            "leave-from-class": "transform scale-100 opacity-100",
            "leave-to-class": "transform scale-95 opacity-0"
          }, {
            default: i(() => [
              v(a(j), {
                class: L([
                  "z-dropdown base-menu__items fixed flex flex-col overflow-hidden rounded-md bg-[var(--background-bg-default)]",
                  l.itemsClass || void 0
                ]),
                style: F(x.value)
              }, {
                default: i(() => [
                  e.$slots.prepend ? (s(), r(a(S), {
                    key: 0,
                    as: "div",
                    class: "base-menu__prepend shrink-0 p-1"
                  }, {
                    default: i(() => [
                      b(e.$slots, "prepend")
                    ]),
                    _: 3
                  })) : g("", !0),
                  (s(!0), T(V, null, O(l.items, (o) => (s(), r(a(S), {
                    class: "base-menu__item",
                    key: o.label,
                    onClick: (c) => $(o)
                  }, {
                    default: i(() => [
                      p("div", q, [
                        l.showIcons && o.icon ? (s(), r(U, {
                          key: 0,
                          name: o.icon,
                          size: "sm",
                          color: "var(--font-color-default)"
                        }, null, 8, ["name"])) : g("", !0),
                        p("span", D, P(o.label), 1)
                      ])
                    ]),
                    _: 2
                  }, 1032, ["onClick"]))), 128))
                ]),
                _: 3
              }, 8, ["class", "style"])
            ]),
            _: 3
          })
        ]))
      ]),
      _: 3
    }));
  }
});
export {
  K as default
};
